const colors = {
  limeGreen: "hsl(163, 72%, 41%)",
  brightRed: "hsl(356, 69%, 56%)",
  facebook: "hsl(208, 92%, 53%)",
  twitter: "hsl(203, 89%, 53%)",
  instagram: "linear-gradient(90deg, hsl(37, 97%, 70%), hsl(329, 70%, 58%))",
  youTube: "hsl(348, 97%, 39%)",
  toggleDark:
    "linear-gradient(45deg, hsl(210, 78%, 56%) 10%, hsl(146, 68%, 55%))",
  toggleLight: "hsl(230, 22%, 74%)",
  veryDarkBlue: "hsl(230, 17%, 14%)",
  veryDarkBlueTop: "hsl(232, 19%, 15%)",
  darkDesaturatedBlueCardBG: "hsl(228, 28%, 20%)",
  desaturatedBlueText: "hsl(228, 34%, 66%)",
  white: "hsl(0, 0%, 100%)",
  cardOnHoverDark: "hsl(228, 25%, 27%)",
  veryPaleBlueTopBG: "hsl(225, 100%, 98%)",
  lightGrayishBlueCardBG: "hsl(227, 47%, 96%)",
  darkGrayishBlueText: "hsl(228, 12%, 44%)",
  cardOnHoverLight: "hsl(228, 33%, 91%)",
};

export default colors;
